import { PaginationItem as _PaginationItem, PaginationItemProps as _PaginationItemProps } from "reactstrap";

    export const PaginationItem = _PaginationItem;
    export type PaginationItemProps = _PaginationItemProps;
    